import { IntegrationConfig } from 'modules/Integrations/domain'
import logo from './googleSheetsLogo.svg'
import { NoConfiguration } from 'modules/Integrations/integrationsConfig/common/NoConfiguration'
import { GoogleSheetsIntegrationDetail } from 'modules/Integrations/integrationsConfig/googleSheets/GoogleSheetsIntegrationDetail'

export const googleSheetsIntegrationConfig: IntegrationConfig = {
  logoUrl: logo,
  smallLogoUrl: logo,
  statusLabel: null,
  documentationUrl: 'https://docs.sequencehq.com/connectors/data-overview',
  title: 'Google Sheets',
  features: {
    canDeleteLinks: false,
    canUninstall: false,
    isDocumentationOnly: true
  },
  description: 'Sync Sequence data to your data stack.',
  components: {
    detail: GoogleSheetsIntegrationDetail,
    management: NoConfiguration
  }
}
